module.exports = __webpack_public_path__ + "img/Andrew-Stephen-Secretary-Treasurer-2022-bilingual.df16ee88.jpg";